import styled from "styled-components";
import { fontSize, colors } from "./variables";

export const TextPage = styled.p`
	font-size: ${fontSize.sm};
	color: ${colors.primary};
	margin: 1rem 0;
`;
